import { Injectable } from '@angular/core';
import { INavigationService } from '../interfaces/navigation.abstract.service';
import { IContextService } from '../interfaces/context.abstract.service';

@Injectable()
export class NavigationServiceMock implements INavigationService {

    constructor(private contextService: IContextService) {}

    getMenuConfigurations(): any {
        return '';
    }
    getParentPageId(): string {
        return '';
    }
    setParentPageId(parentPageId: string): any {
        return '';
    }
    getChildPageName(url: string): string {
        return '';
    }
    setQueryParams(url: string): any {
        return '';
    }
    getQueryParams(): any {
        return '';
    }
    getGroupName(): string {
        return '';
    }
    getDeviceType(): string {
        return '';
    }
    setChildPageId(childId: string): any {
        return '';
    }
    getChildPageId(): string {
        return '';
    }
    handleNavigation(navigation: any): any {
        return '';
    }
    handleNavigationWithDomain(domain: string): any {
        return '';
    }
    setCurrentUrl(url: string): any {
        return '';
    }
    getCurrentUrl(): any {
        return '';
    }
    setParentPage(parentPage: any): any {
        return '';
    }
    getParentPage(): any {
        return '';
    }
    setChildPage(childpage: any): any {
        return '';
    }
    getChildPage(): any {
        return '';
    }
    setGrandChildPageId(grandChildId: string): any {
        return '';
    }
    getGrandChildPageId(): string {
        return '';
    }
     setGrandChildPage(grandChildPage: any) {
    }
    getGrandChildPage(): any {
        return '';
    }
    setFourthChildPageId(fourthChildId: string): any {
        return '';
    }
    getFourthChildPageId(): string {
        return '';
    }

    setFourthChildPage(fourthChildPage: any) {}

    getFourthChildPage(): any {
        return undefined;
    }

    setComingSoonMsgInd() {}

    getComingSoonMsgInd(): any {
        return undefined;
    }

    // TODO: May need to pass some page object instead of a targetUrl string
    setContextAndNavigate(domain: string, value: any, targetUrl: string): any {
        // console.log(`Changing to the ${domain} context for account number ${value}`);
        this.contextService.setDomainContext(domain, value);
        const event = new CustomEvent('navigate', { detail: { context: domain, value: value } });
        dispatchEvent(event);
    }

    navigateOnContext(contextType: string, contextValue: any): any {
        return null;
    }

    navigateOnAction(contextType: string, contextValue: any, target: string): any {
        return null;
    }

}
